import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "display-flex ion-justify-content-center" }
const _hoisted_2 = { class: "display-flex ion-justify-content-center" }
const _hoisted_3 = { class: "display-flex ion-justify-content-center" }
const _hoisted_4 = { class: "display-flex ion-justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_thinking_icon = _resolveComponent("thinking-icon")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_box_icon = _resolveComponent("box-icon")!
  const _component_join_us_icon = _resolveComponent("join-us-icon")!
  const _component_fun_icon = _resolveComponent("fun-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentIndex === 0)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 0,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_lottie_animation, {
                class: "icon-container",
                "animation-data": _ctx.retentionAnimation
              }, {
                fallback: _withCtx(() => [
                  _createVNode(_component_thinking_icon, {
                    "fill-color-variable": '--ion-color-primary',
                    "stroke-color-variable": '--ion-color-primary'
                  })
                ]),
                _: 1
              }, 8, ["animation-data"])
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Ever wonder why you can remember words you learned as a child but forget new ones after just a few days? ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 1)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 1,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_lottie_animation, {
                class: "icon-container",
                "animation-data": _ctx.spacedRepetitionAnimation
              }, {
                fallback: _withCtx(() => [
                  _createVNode(_component_box_icon, {
                    "fill-color-variable": '--ion-color-primary',
                    "stroke-color-variable": '--ion-color-primary'
                  })
                ]),
                _: 1
              }, 8, ["animation-data"])
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" That's where ", -1),
                _createElementVNode("strong", null, "spaced repetition", -1),
                _createTextVNode(" comes in! The ", -1),
                _createElementVNode("strong", null, "Leitner system", -1),
                _createTextVNode(" helps you remember words by reviewing ", -1),
                _createElementVNode("strong", null, "flashcards", -1),
                _createTextVNode(" at intervals based on how well you remember them. ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 2)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 2,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_lottie_animation, {
                class: "icon-container",
                "animation-data": _ctx.joinUsAnimation
              }, {
                fallback: _withCtx(() => [
                  _createVNode(_component_join_us_icon, {
                    "fill-color-variable": '--ion-color-primary',
                    "stroke-color-variable": '--ion-color-primary'
                  })
                ]),
                _: 1
              }, 8, ["animation-data"])
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Learning is better together! Join a cohort, discover new words, and strengthen your vocabulary through regular practice. ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.currentIndex === 3)
      ? (_openBlock(), _createBlock(_component_ion_card, {
          key: 3,
          class: "margin-top-bottom-unset"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_lottie_animation, {
                class: "icon-container",
                "animation-data": _ctx.funGameAnimation
              }, {
                fallback: _withCtx(() => [
                  _createVNode(_component_fun_icon, {
                    "fill-color-variable": '--ion-color-primary',
                    "stroke-color-variable": '--ion-color-primary'
                  })
                ]),
                _: 1
              }, 8, ["animation-data"])
            ]),
            _createVNode(_component_ion_card_title, { class: "ion-padding-top ion-text-center" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Make learning more fun with our ", -1),
                _createElementVNode("strong", null, "word guessing game", -1),
                _createTextVNode("! Use clues to find the right word and reinforce what you've learned. ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}